import {
	attachContactSearchText,
	CONTACT_SEARCH_TEXT_KEY,
	matchesPreparedContactKeyword
} from './contactSearchMatcher';

function normalizeArray(values) {
	return Array.isArray(values) ? values : [];
}

function resolveIdKey(id) {
	if (id === undefined || id === null || id === '') {
		return '';
	}
	return String(id);
}

function resolveFriendDisplayName(friend) {
	if (!friend) {
		return '';
	}
	return friend.showNickName || friend.nickName || friend.userName || '';
}

export function resolveFriendGroupMembers(group, friendStore, friendGroupStore = null) {
	if (!group || !friendStore) {
		return [];
	}
	const friendMap = new Map();
	const runtimeGroupStore = friendGroupStore || friendStore.friendGroupStore || null;
	if (runtimeGroupStore && group.id) {
		normalizeArray(runtimeGroupStore.findGroupFriends(group.id)).forEach((friend) => {
			if (!friend || friend.deleted) {
				return;
			}
			const friendKey = resolveIdKey(friend.id);
			if (!friendKey) {
				return;
			}
			friendMap.set(friendKey, friend);
		});
	}
	return Array.from(friendMap.values());
}

export function buildFriendGroupOption(group, friendStore, friendGroupStore = null) {
	const members = resolveFriendGroupMembers(group, friendStore, friendGroupStore);
	const memberNames = members.map((friend) => resolveFriendDisplayName(friend)).filter(Boolean);
	const previewNames = memberNames.slice(0, 3);
	const sourceMemberCount = Number(group && group.memberCount);
	const memberCount = Number.isFinite(sourceMemberCount)
		? sourceMemberCount
		: members.length;
	const friendIds = members.map((friend) => friend.id);
	const loadedMemberCount = friendIds.length;
	return attachContactSearchText({
		id: group.id,
		name: group.name || '',
		friendIds,
		memberCount,
		loadedMemberCount,
		membersFullyLoaded: memberCount === loadedMemberCount,
		memberNames,
		previewNames,
		previewText: previewNames.join('、')
	});
}

export function filterFriendGroupOptions(groups, keyword) {
	return normalizeArray(groups).filter((group) => {
		return matchesPreparedContactKeyword(group && group[CONTACT_SEARCH_TEXT_KEY], keyword);
	});
}

export function countFriendGroupNewMembers(group, selectedIds) {
	const selectedIdSet = selectedIds instanceof Set
		? new Set(Array.from(selectedIds).map((id) => resolveIdKey(id)).filter(Boolean))
		: new Set(normalizeArray(selectedIds).map((id) => resolveIdKey(id)).filter(Boolean));
	const memberCount = Number(group && group.memberCount);
	const totalCount = Number.isFinite(memberCount) && memberCount > 0 ? memberCount : 0;
	const friendIds = normalizeArray(group && group.friendIds);
	if (friendIds.length === 0) {
		return totalCount;
	}
	let visibleLoadedCount = 0;
	friendIds.forEach((friendId) => {
		if (!selectedIdSet.has(resolveIdKey(friendId))) {
			visibleLoadedCount += 1;
		}
	});
	if (group && group.membersFullyLoaded) {
		return visibleLoadedCount;
	}
	const hiddenUnloadedCount = Math.max(totalCount - friendIds.length, 0);
	return visibleLoadedCount + hiddenUnloadedCount;
}

export function buildPrivateChatTargetsFromFriendGroup(group, friendStore, friendGroupStore = null) {
	return resolveFriendGroupMembers(group, friendStore, friendGroupStore).map((friend) => {
		return {
			type: 'PRIVATE',
				targetId: friend.id,
				showName: resolveFriendDisplayName(friend),
				headImage: friend.headImage,
				userName: friend.userName || ''
			};
	});
}
